// eslint-disable-next-line import/prefer-default-export
export function capitalizeFLetter(str?: string): string {
  return str?.toLowerCase().replace(/^./, str[0].toUpperCase());
}

export const extractMobileNumber = (mobileNumber: string): string => {
  // If to match either '+66' or '+63' at the beginning
  const match = mobileNumber.match(/^(\+66|\+63)(.*)/);
  return match ? match[2] : mobileNumber;
};

type DropdownItem = {
  label: string;
  value: string;
};

export const getLabelFromValue = (
  value: string,
  list: DropdownItem[]
): string => {
  if (!value) {
    return '-';
  }
  const foundItem = list?.find((item) => item.value === value);
  return foundItem ? foundItem.label : '-';
};
